import { useMutation, useQuery } from "@tanstack/react-query";
import { AxiosInstance } from "./auth/AxiosInstance";

export const useUpdateProfile = () => {
    return useMutation({
        mutationFn: async (data) => {
            const response = await AxiosInstance.put('/users/profile', data);
            return response.data;
        }
    })
}

export const useChangePassword = () => {
    return useMutation({
        mutationFn: async (data) => {
            const response = await AxiosInstance.put('/users/change-password', data);
            return response.data;
        }
    })
}

export const useRequestSettingsChange = () => {
    return useMutation({
        mutationFn: async () => {
            const response = await AxiosInstance.post('/users/request-settings-change');
            return response.data;
        }
    })
}

export const useChangeEmail = () => {
    return useMutation({
        mutationFn: async (data) => {
            const response = await AxiosInstance.put('/users/email', data);
            return response.data;
        }
    })
}

export const useUpdateUsername = () => {
    return useMutation({
        mutationFn: async (data) => {
            const response = await AxiosInstance.put('/users/username', data);
            return response.data;
        }
    })
}

export const useUpdatePreferences = () => {
    return useMutation({
        mutationFn: async (data) => {
            const response = await AxiosInstance.put('/users/preferences', data);
            return response.data;
        }
    })
}
export const useCheckUsernameAvailability = () => {
    return useMutation({
        mutationFn: async (username) => {
            const response = await AxiosInstance.get(`/users/check-username?username=${username}`);
            return response.data;
        }
    })
}

export const useGenerate2FA = () => {
    return useMutation({
        mutationFn: async () => {
            const response = await AxiosInstance.post('/users/2fa/generate');
            return response.data;
        }
    })
}

export const useVerify2FASetup = () => {
    return useMutation({
        mutationFn: async (data) => {
            const response = await AxiosInstance.post('/users/2fa/verify-setup', data);
            return response.data;
        }
    })
}

export const useDisable2FA = () => {
    return useMutation({
        mutationFn: async (data) => {
            const response = await AxiosInstance.post('/users/2fa/disable', data);
            return response.data;
        }
    })
}

export const useGetTopHellocians = () => {
    return useQuery({
        queryKey: ['topHellocians'],
        queryFn: async () => {
            const response = await AxiosInstance.get('/users/top-hellocians');
            return response.data;
        }
    })
}

export const useGetHellocianMetrics = () => {
    return useQuery({
        queryKey: ['hellocianMetrics'],
        queryFn: async () => {
            const response = await AxiosInstance.get('/users/metrics');
            return response.data.metrics;
        }
    })
}
